import Vue from 'vue';

export default (id, params = {}, type = 'single') => (
  new Promise((resolve, reject) => {
    let url = '';
    if (type === 'bulk') {
      url = '/warehouses/stock_management';
    } else {
      url = `/warehouses/stock_management/${id}`;
    }
    Vue.$http.post(url, params)
    .then((response) => {
      resolve(response.data);
    })
    .catch((error) => {
      reject(error.response.data);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/warehouse/stockManagement.js